import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {TooltipModule} from 'primeng/tooltip';
import {MatRippleModule} from '@angular/material/core';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MiscModule} from 'projects/core/src/public-api';
import {RouterModule} from '@angular/router';
import {AdminPanelComponent} from './view/admin-panel/admin-panel.component';
import {EmailChangerComponent} from './view/email-changer/email-changer.component';
import {MatButtonModule} from '@angular/material/button';
import {EmailChangerDialogComponent} from './view/email-changer/email-changer-dialog/email-changer-dialog.component';
import {InputTextModule} from 'primeng/inputtext';
import {DictionariesEditorComponent} from './view/dictionaries-editor/dictionaries-editor.component';
import {DictionaryEditorDialogComponent} from './view/dictionaries-editor/dictionary-editor-dialog/dictionary-editor-dialog.component';
import {ColorPickerModule} from 'primeng/colorpicker';
import {AccessEditorComponent} from './view/access-editor/access-editor.component';
import {AccessEditorDialogComponent} from './view/access-editor/access-editor-dialog/access-editor-dialog.component';
import {ListboxModule} from 'primeng/listbox';
import {CheckboxModule} from 'primeng/checkbox';
import {ActivitiesEditorComponent} from './view/activities-editor/activities-editor.component';
import {ActivityEditorDialogComponent} from './view/activities-editor/activity-editor-dialog/activity-editor-dialog.component';
import {InputSwitchModule} from 'primeng/inputswitch';
import {CalendarModule} from 'primeng/calendar';
import {MultiSelectModule} from 'primeng/multiselect';
import {KbColumnEditorComponent} from './view/kb-column-editor/kb-column-editor.component';
import {KbColumnEditorDialogComponent} from './view/kb-column-editor/kb-column-editor-dialog/kb-column-editor-dialog.component';
import {SystemNfsChangerComponent} from './view/system-nfs-changer/system-nfs-changer.component';
import {SystemNfsEditorDialogComponent} from './view/system-nfs-changer/system-nfs-editor-dialog/system-nfs-editor-dialog.component';
import {NfsSubEditorComponent} from './view/system-nfs-changer/nfs-sub-editor/nfs-sub-editor.component';
import {DropdownModule} from 'primeng/dropdown';
import {ItemEditorComponent} from './view/item-editor/item-editor.component';
import {TableModule} from 'primeng/table';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {GradeEditorComponent} from './view/grade-editor/grade-editor.component';
import {ProjectMiscModule} from '../project-misc/project-misc.module';
import {PricingCategoriesEditorComponent} from './view/pricing-categories-editor/pricing-categories-editor.component';
import {PricingModifEditorComponent} from './view/pricing-modif-editor/pricing-modif-editor.component';
import {CategoryEditorDialogComponent} from './view/pricing-categories-editor/category-editor-dialog/category-editor-dialog.component';
import {ModifierEditorDialogComponent} from './view/pricing-categories-editor/category-editor-dialog/modifier-editor-dialog/modifier-editor-dialog.component';
import {InputNumberModule} from 'primeng/inputnumber';
import { MultiplicationEditorDialogComponent } from './view/pricing-categories-editor/multiplication-editor-dialog/multiplication-editor-dialog.component';
import {FeeEditorDialogComponent} from './view/pricing-categories-editor/fee-editor-dialog/fee-editor-dialog.component';
import { MiscItemFilesDialogComponent } from './view/item-editor/misc-item-files-dialog/misc-item-files-dialog.component';
import {FileUploadModule} from 'primeng/fileupload';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {ProdPostEditorDialogComponent} from './view/activities-editor/prod-post-editor-dialog/prod-post-editor-dialog.component';
import { ActivityDurationEditBlockComponent } from './view/activities-editor/activity-duration-edit-block/activity-duration-edit-block.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {KbPresetEditorDialogComponent} from './view/kb-column-editor/kb-preset-editor-dialog/kb-preset-editor-dialog.component';

@NgModule({
  declarations: [
    AdminPanelComponent,
    EmailChangerComponent,
    EmailChangerDialogComponent,
    DictionariesEditorComponent,
    DictionaryEditorDialogComponent,
    AccessEditorComponent,
    AccessEditorDialogComponent,
    ActivitiesEditorComponent,
    ActivityEditorDialogComponent,
    ProdPostEditorDialogComponent,
    KbColumnEditorComponent,
    KbColumnEditorDialogComponent,
    KbPresetEditorDialogComponent,
    SystemNfsChangerComponent,
    SystemNfsEditorDialogComponent,
    NfsSubEditorComponent,
    ItemEditorComponent,
    GradeEditorComponent,
    PricingCategoriesEditorComponent,
    PricingModifEditorComponent,
    CategoryEditorDialogComponent,
    ModifierEditorDialogComponent,
    MultiplicationEditorDialogComponent,
    FeeEditorDialogComponent,
    MiscItemFilesDialogComponent,
    ActivityDurationEditBlockComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    RouterModule,
    MiscModule,
    MatInputModule,
    MatIconModule,
    MatDialogModule,
    MatRippleModule,
    MatButtonModule,
    InputTextModule,
    TooltipModule,
    ListboxModule,
    CheckboxModule,
    ColorPickerModule,
    InputSwitchModule,
    InputNumberModule,
    CalendarModule,
    MultiSelectModule,
    DropdownModule,
    TableModule,
    ConfirmDialogModule,
    ProjectMiscModule,
    FileUploadModule,
    MatProgressBarModule,
    DragDropModule
  ],
    exports: [
      ActivityEditorDialogComponent,
      ProdPostEditorDialogComponent
    ],
  entryComponents: []

})
export class AdminPanelModule {
}
